module.exports = __webpack_public_path__ + "img/AI时尚趋势分析banner1.4727316d.png";